export const getShortThumbprint = (thumbprint: string): string => {
    const ensureStringThumbprint = thumbprint + '';
    return `${ensureStringThumbprint.substring(0, 4)}...${ensureStringThumbprint.slice(-4)}`;
};

export const capitalizeFirstLetter = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
